import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '../constants/app-constants';
import { AuthService } from './auth.service';
import { UserCacheService } from './user-cache.service';
@Injectable()
export class PublicGuardService  {
    constructor(public auth: AuthService, public router: Router, public userCacheService: UserCacheService) { }
    canActivate(): boolean {
        if (this.auth.isAuthenticated()) {
            const participantId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
            this.router.navigate([participantId + '/login']);
            return false;
        }
        return true;
    }
}
